import React from 'react'

export function Button({children, href, variant = 'primary', size = '', full, onClick, type = 'button', target, rel}) {
  const className = ['hlm-btn', `hlm-btn-${variant}`, size ? `hlm-btn-${size}` : '', full ? 'hlm-btn-full' : ''].filter(Boolean).join(' ')

  if (href) {
    return (
      <a href={href} className={className} onClick={onClick} target={target} rel={rel}>
        {children}
      </a>
    )
  }

  return (
    <button type={type} className={className} onClick={onClick}>
      {children}
    </button>
  )
}
